<template>
  <div id="admin_overdue_promotions_list">
    <CardedTable :items="items" :headers="headers">
      
      <template v-slot:[`item.expiry`]="{ item }">
        <span class="red--text" v-if="item.expiry == 'overdue'"><b>Overdue</b></span>
      </template>
      <template v-slot:[`item.has_been_ended`]="{ item }">
        <span class="red--text" v-if="parseInt(item.has_been_ended) == 1"><b>Ended</b></span>
        <!-- <span class="blue--text" v-if="parseInt(item.is_verified) == 1"><b>Processing</b></span> -->
        <span class="green--text" v-if="parseInt(item.has_been_ended) == 0"><b>Active</b></span>
      </template>

      
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from '../../../lib/Utils';
export default {
  name: "AdminPromotionsOverdue",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
          return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
        _user: null,
      items: [],
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
          filterable: true,
        },
        {
          text: "Business",
          align: "start",
          sortable: false,
          value: "business.name",
          filterable: true,
        },
        {
          text: "Starts",
          align: "center",
          sortable: true,
          value: "starts_on",
          filterable: true,
        },
        {
          text: "Ends",
          align: "center",
          sortable: true,
          value: "ends_on",
          filterable: true,
        },
        {
          text: "Expiry",
          align: "start",
          sortable: true,
          value: "expiry",
          filterable: true,
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "has_been_ended",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end", },
      ],
      indexed_businesses: {}
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotions(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          var php_time_now = Utils.date_str_to_php_time();
          //console.log("php_time_now:",php_time_now);
          var temp = [];
          for (var index = 0; index < res.length; index++) {
            var promotion = res[index];
            promotion.expiry = "";
            if(parseInt(promotion.has_been_ended) == 0 &&  php_time_now > parseFloat(promotion.ends_on_timestamp) ){
                promotion.expiry = "overdue";
                temp.push(promotion);
            }
          }
          this.items = temp;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading overdue prmomotions on admin promotions list", errors);
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/promotions/list/view/" + item.id);
    },
  },
  mounted() {
      this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "List Of Overdue Promotions",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "Overdue",
          disabled: true,
          href: "/admin/promotions/overdue",
        },
      ],
    });
    this.load_items();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_overdue_promotions_list", options);
  },
};
</script>